import { NetworkSettings } from "../../config/NetworkSettings";
import { WorldAssignmentGlobals } from "../../config/WorldAssignmentGlobals";

export class Context {
    private static _instance: Context;
    private _components: Map<string, any>;

    private constructor() {
        this._components = new Map();
    }

    // if provided a constructor for type `T`, this will return an instances of `T`
    public get<T>(key: { new(...args: any[]): T }): T;
    public get(key: Function | string): any {
        let _key: string;
        if (typeof key === "function") {
            _key = key.name;
        } else {
            _key = key;
        }
        return this._components.get(_key);
    }

    public set(obj: any, key?: string | Function) {
        let _key: string;
        if (typeof key === "function") {
            /* deal with unnamed functions */
            _key = key.name;
        } else if (typeof key === "string") {
            _key = key;
        } else {
            _key = obj.constructor.name;
        }
        this._components.set(_key, obj);

        if ("initialize" in obj) {
            obj.initialize();
        }
    }

    public get globals(): WorldAssignmentGlobals {
        return this.get(WorldAssignmentGlobals);
    }

    public set globals(value: WorldAssignmentGlobals) {
        this.set(value, WorldAssignmentGlobals);
    }

    public get networkSettings(): NetworkSettings {
        return this.get(NetworkSettings);
    }

    public set networkSettings(value: NetworkSettings) {
        this.set(value, NetworkSettings);
    }

    public static get instance() {
        return this._instance || (this._instance = new this());
    }
}
